(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["va-spa-preview-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('va-spa-layout')) {
  customElements.define('va-spa-layout', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('.va-spa-demo video');
      this.events = new AbortController();
      if (this.video) {
        const video = this.video;
        const play = () => {
          const attempt = video.play();
          if (attempt) attempt.catch(() => {});
        };
        document.querySelectorAll('.va-spa-video-link').forEach(link => {
          link.addEventListener('click', () => {
            if (this.videoObserver) this.videoObserver.disconnect();
            play();
          }, { signal: this.events.signal });
        });
        video.addEventListener('play', () => {
          if (this.videoObserver) this.videoObserver.disconnect();
        }, { signal: this.events.signal });
        if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.videoObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.45)) {
              this.videoObserver.disconnect();
              play();
            }
          }, { threshold: 0.45 });
          this.videoObserver.observe(video);
        }
      }
      const info = document.querySelector('.product__info-container:has(.va-spa-buy)');
      if (!info) return;
      const placements = [
        ['.vtl-pr-main-widget--product-page', '[data-va-spa-reviews]'],
        ['.vtl-rp-main-widget', '[data-va-spa-recommendations]']
      ];
      const arrange = () => {
        let complete = true;
        placements.forEach(([selector, destination]) => {
          const target = this.querySelector(destination);
          const widget = info.querySelector(selector);
          if (target && widget) target.appendChild(widget);
          if (!target || !target.querySelector(selector)) complete = false;
        });
        if (complete && this.observer) this.observer.disconnect();
        return complete;
      };
      if (!arrange()) {
        this.observer = new MutationObserver(arrange);
        this.observer.observe(info, { childList: true, subtree: true });
        this.timeout = setTimeout(() => this.observer.disconnect(), 60000);
      }
    }
    disconnectedCallback() {
      if (this.videoObserver) this.videoObserver.disconnect();
      if (this.events) this.events.abort();
      if (this.video) this.video.pause();
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.timeout);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
